// 旧 FCM の Service Worker を起動時に撤去する（設計書 §9.7-2）。
// develop は index.tsx でスコープ `/` に、getToken が SDK 既定のスコープ
// `/firebase-cloud-messaging-push-scope/` に同じスクリプトを登録していた。
// 購読は後者に付くため、両方を撤去対象にする。
const LEGACY_FCM_SW_SCOPES: readonly string[] = [
  '/',
  '/firebase-cloud-messaging-push-scope',
]
const LEGACY_FCM_SW_PATH = '/firebase-messaging-sw.js'

// SW のスコープは末尾が `/` になるため、比較前に正規化する
function normalizeScopePath(pathname: string): string {
  return pathname.length > 1 && pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname
}

function registrationScopePath(
  registration: ServiceWorkerRegistration,
): string | null {
  try {
    return new URL(registration.scope).pathname
  } catch {
    return null
  }
}

function registrationScriptPath(
  registration: ServiceWorkerRegistration,
): string | null {
  const scriptUrl =
    registration.active?.scriptURL ??
    registration.waiting?.scriptURL ??
    registration.installing?.scriptURL
  if (!scriptUrl) return null
  try {
    return new URL(scriptUrl).pathname
  } catch {
    return null
  }
}

function isLegacyFcmRegistration(
  registration: ServiceWorkerRegistration,
): boolean {
  const scopePath = registrationScopePath(registration)
  if (scopePath === null) return false
  return (
    LEGACY_FCM_SW_SCOPES.includes(normalizeScopePath(scopePath)) &&
    registrationScriptPath(registration) === LEGACY_FCM_SW_PATH
  )
}

// 購読の解除を FCM トークンの削除の代わりにする。失敗しても撤去は続ける。
async function removeLegacyFcmRegistration(
  registration: ServiceWorkerRegistration,
): Promise<void> {
  try {
    const subscription = await registration.pushManager.getSubscription()
    await subscription?.unsubscribe()
  } catch {
    // 購読が無い・解除できない場合も登録解除は行う
  }

  try {
    await registration.unregister()
  } catch {
    // 登録解除の失敗で起動を止めない
  }
}

// Web Push の SW（スコープ `/web-push/`）とその購読は lib/webPush.ts が所有するので触らない。
export async function unregisterLegacyFcmServiceWorker(): Promise<void> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return
  }

  let registrations: readonly ServiceWorkerRegistration[]
  try {
    registrations = await navigator.serviceWorker.getRegistrations()
  } catch {
    return
  }

  await Promise.all(
    registrations
      .filter(isLegacyFcmRegistration)
      .map((registration) => removeLegacyFcmRegistration(registration)),
  )
}
